// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getHost = (): string | undefined =>
  (globalThis as any).commonConfig?.host;

// Editor-side checks only. Live-site widgets receive the persisted flags from
// their controllers because commonConfig.host is VIEWER there.
export const isEditor3EditorContext = (): boolean => getHost() === 'EDITOR3';

export const isStudio2EditorContext = (): boolean => getHost() === 'STUDIO2';

export const isStudioEditorContext = (): boolean => getHost() === 'STUDIO';
